import React, { useMemo } from "react";
import { ClockCircleOutlined } from "@ant-design/icons";
import { Select } from "antd";
import { SelectProps } from "antd/es/select";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";

// Helpers
import { getClassName } from "src/helpers/common.helper";

// Constants
import { BRANCH_AVAILABLES_TIMES } from "src/constants";

type Props = SelectProps;

const filterOption = (input: string, option: SelectOption) => {
    return (option.value as string).includes(input);
};

const CarSearchTimePicker = (props: Props) => {
    const options = useMemo(() => {
        return BRANCH_AVAILABLES_TIMES.map((value) => (
            <Select.Option key={value} value={value}>
                <OptionDivStyled className="time-option">
                    <div className="option">{value}</div>
                    <div className="selected">
                        <ClockCircleOutlined /> <span>{value}</span>
                    </div>
                </OptionDivStyled>
            </Select.Option>
        ));
    }, []);

    return (
        <SelectStyled
            {...props}
            className={getClassName(
                "car-search-time-picker",
                props.className ?? ""
            )}
            placeholder={
                <>
                    <ClockCircleOutlined />{" "}
                    <span>
                        <FormattedMessage id="selectTime" />
                    </span>
                </>
            }
            showSearch
            optionFilterProp="children"
            filterOption={filterOption}
        >
            {options}
        </SelectStyled>
    );
};

const SelectStyled = styled(Select)<any>`
    &.car-search-time-picker {
        width: 123px;

        .ant-select-selector {
            width: 123px !important;

            .time-option {
                & > .option {
                    display: none;
                }
                & > .selected {
                    display: block;

                    .anticon {
                        color: rgba(0, 0, 0, 0.25);
                    }
                }
            }
        }
    }
`;

const OptionDivStyled = styled.div`
    &.time-option {
        .option {
            display: block;
        }
        .selected {
            display: none;
        }
    }
`;

export default CarSearchTimePicker;
